import {PermissionsAndroid} from 'react-native';
import Geolocation from 'react-native-geolocation-service';
import AsyncStorage from '@react-native-async-storage/async-storage';
import FaJson from 'src/i18n/fa-IR.json';
import {showAlert} from '../actions/AlertActions';
import {getApp} from '../actions/app';
import {getMap} from '../actions/map';
import {getModal} from '../actions/modal';
import {isAndroid, isWeb} from '../constants';
import {store} from '../store';
/**
 *  ┌──────────────────────────────────────────┐
 *  │              getUserLocation             │
 *  └──────────────────────────────────────────┘
 *
 *                 [Start]
 *                    │
 *         ┌──────────┴──────────┐
 *         │                     │
 *       [Web]                [Android/iOS]
 *         │                     │
 *   ┌─────▼─────┐        ┌──────▼──────┐
 *   │ Check     │        │ Check        │
 *   │ permission│        │ permission   │
 *   └─────┬─────┘        └──────┬──────┘
 *         │ Granted              │ Granted
 *         ▼                      ▼
 *   ┌─────────────┐        ┌──────────────┐
 *   │navigator.   │        │Geolocation.   │
 *   │geolocation  │        │getCurrentPos()│
 *   └─────┬───────┘        └──────┬───────┘
 *         │                        │
 *         ▼                        ▼
 *   ┌───────────────┐       ┌───────────────┐
 *   │ Validate data │       │ Validate data │
 *   │ (accuracy &   │       │ (accuracy &   │
 *   │ distance)     │       │ distance)     │
 *   └───────┬───────┘       └───────┬───────┘
 *           │                       │
 *      Invalid? yes → Retry   Invalid? yes → Retry
 *           │                       │
 *           ▼                       ▼
 *   ┌───────────────┐       ┌───────────────┐
 *   │ Save to Redux │       │ Save to Redux │
 *   └───────────────┘       └───────────────┘
 *           │                       │
 *           └───────────► [Success] ◄──────────┘
 */

/**
 * گرفتن لوکیشن کاربر (وب + اندروید/iOS)
 * - روی وب: از navigator.geolocation
 * - روی موبایل: از react-native-geolocation-service
 * - نتیجه → ذخیره در Redux
 */
export const getUserLocation = props => {
  const onSuccess = props?.onSuccess;
  const onError = props?.onError;
  const timeout = props?.timeout ?? 8000; // تغییر به 8000ms
  const enableHighAccuracy = props?.enableHighAccuracy ?? true;

  try {
    if (isWeb) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            console.log('[LOCATION SUCCESS] Web position:', position.coords);
            store.dispatch(
              getMap({
                userPosition: {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                  accuracy: position.coords.accuracy,
                  timestamp: position.timestamp,
                  locationPermition: true,
                },
              }),
            );
            onSuccess && onSuccess(position);
          },
          err => {
            console.warn('[LOCATION ERROR] Web failed:', err);
            if (err.code === 1) {
              AsyncStorage.getItem('locationModalSeen').then(value => {
                console.log('locationModalSeen value:', value);
                if (!value) {
                  console.log('نمایش مودال دسترسی لوکیشن');
                  store.dispatch(getApp({permitionModal: true}));
                } else {
                  console.log('کاربر قبلاً مودال را دیده است');
                }
              });
            }
            onError && onError(err);
          },
          {enableHighAccuracy, timeout, maximumAge: 0},
        );
      }
    } else {
      Geolocation.getCurrentPosition(
        position => {
          console.log('[LOCATION SUCCESS] Mobile position:', position.coords);
          onSuccess && onSuccess(position);
          store.dispatch(
            getMap({
              userPosition: {
                lat: position.coords?.latitude,
                lng: position.coords?.longitude,
                accuracy: position.coords?.accuracy,
                timestamp: position?.timestamp ?? 0,
                locationPermition: true,
              },
            }),
          );
        },
        error => {
          console.warn('[LOCATION ERROR] Mobile failed:', error);
          store.dispatch(getMap({locationPermition: false}));
          onError && onError(error);
        },
        {
          enableHighAccuracy: true,
          timeout,
          maximumAge: 0,
          showLocationDialog: true,
          forceRequestLocation: false,
        },
      );
    }
  } catch (err) {
    console.error('[LOCATION EXCEPTION]', err);
    onError && onError(err);
  }
};

/**
 * چک کردن دسترسی لوکیشن + گرفتن لوکیشن
 * - وب: مستقیم getUserLocation
 * - اندروید: اگر دسترسی نداده بود → درخواست
 * - اگر رد کرد یا never ask again زد → نمایش پیام مناسب
 */
export const checkPermitionAndGetPosition = props => {
  const onPermissionDenied = message => {
    props?.onError &&
      props.onError({
        code: 1,
        message: message || 'permission denied',
      });
  };

  if (isWeb) {
    getUserLocation(props);
    return;
  }

  if (!isAndroid) {
    getUserLocation(props);
    return;
  }

  PermissionsAndroid.check(
    PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
  ).then(result => {
    if (result) {
      getUserLocation(props);
    } else {
      PermissionsAndroid.request(
        PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
      ).then(_result => {
        if (_result === PermissionsAndroid.RESULTS.GRANTED) {
          getUserLocation(props);
        } else if (_result === PermissionsAndroid.RESULTS.DENIED) {
          store.dispatch(
            showAlert({
              id: 'AlertBox',
              modalProps: {
                icon: 'redExclamation',
                title: FaJson.location_permission,
                message: FaJson.location_permission_deny,
              },
            }),
          );
          onPermissionDenied('location permission denied');
        } else if (_result === PermissionsAndroid.RESULTS.NEVER_ASK_AGAIN) {
          const data = {
            modal: true,
            image: 'warningIcon',
            width: 24,
            height: 22,
            text: FaJson.location_permission_never_ask_again_mobile,
            Notification: true,
            func: 'setting',
            btntext: FaJson.open_setting,
          };
          store.dispatch(getModal(data));
          onPermissionDenied('location permission never ask again');
        } else {
          onPermissionDenied('location permission unknown');
        }
      });
    }
  });
};

/**
 * اعتبارسنجی زمان لوکیشن
 * - اگر اختلاف زمان لوکیشن با الان کمتر از X دقیقه باشه → معتبر
 */
export const checkLocationIsValid = (timestamp, validTime) => {
  const nowTimeStamp = new Date().getTime();
  const difference = Math.abs(nowTimeStamp - timestamp);
  return difference < validTime * 60 * 1000;
};

/**
 * گرفتن لوکیشن با اعتبارسنجی فاصله و دقت
 * - اگر فاصله با لوکیشن قبلی خیلی کم بود → دوباره تلاش کن
 * - اگر دقت GPS پایین بود → دوباره تلاش کن
 * - حداکثر تعداد تلاش محدود شده
 */
export const getUserLocationWithValidation = props => {
  const {
    onSuccess,
    onError,
    timeout = 15000,
    enableHighAccuracy = true,
    minDistance = 10, // حداقل فاصله (متر)
    maxRetries = 3, // حداکثر تعداد تلاش
    previousLocation = null,
  } = props;

  let retryCount = 0;

  const attemptGetLocation = () => {
    getUserLocation({
      onSuccess: position => {
        const newLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: position.timestamp,
        };

        // بررسی فاصله با لوکیشن قبلی
        if (previousLocation) {
          const distance = calculateDistance(
            previousLocation.lat,
            previousLocation.lng,
            newLocation.lat,
            newLocation.lng,
          );

          if (distance < minDistance && newLocation.accuracy > 20) {
            if (retryCount < maxRetries) {
              retryCount++;
              setTimeout(attemptGetLocation, 2000);
              return;
            }
          }
        }

        // بررسی دقت
        if (newLocation.accuracy > 50) {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(attemptGetLocation, 2000);
            return;
          }
        }

        onSuccess && onSuccess(position);
      },
      onError: error => {
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(attemptGetLocation, 2000);
        } else {
          onError && onError(error);
        }
      },
      timeout,
      enableHighAccuracy,
    });
  };

  attemptGetLocation();
};

/**
 * محاسبه فاصله بین دو نقطه (فرمول Haversine)
 * خروجی → متر
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // شعاع زمین (متر)
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

/**
 * گرفتن لوکیشن خیلی دقیق
 * - GPS واقعی (forceRequestLocation = true)
 * - timeout بالا (۲۰ ثانیه)
 * - رد کردن لوکیشن‌هایی با دقت بد
 * - اگر فاصله با قبلی خیلی کم بود → خطا
 */
export const getAccurateLocation = props => {
  const {onSuccess, onError, previousLocation = null, minDistance = 10} = props;

  const options = {
    enableHighAccuracy: true,
    timeout: 20000,
    maximumAge: 0,
    forceRequestLocation: true,
    showLocationDialog: true,
  };

  if (isWeb) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const newLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy,
            timestamp: position.timestamp,
          };

          if (newLocation.accuracy > 100) {
            onError &&
              onError({code: 2, message: 'Location accuracy is too low'});
            return;
          }

          if (previousLocation) {
            const distance = calculateDistance(
              previousLocation.lat,
              previousLocation.lng,
              newLocation.lat,
              newLocation.lng,
            );
            if (distance < minDistance) {
              onError && onError({code: 3, message: 'Location is too close'});
              return;
            }
          }

          onSuccess && onSuccess(position);
        },
        onError,
        options,
      );
    }
  } else {
    Geolocation.getCurrentPosition(
      position => {
        const newLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: position.timestamp,
        };

        if (newLocation.accuracy > 100) {
          onError &&
            onError({code: 2, message: 'Location accuracy is too low'});
          return;
        }

        if (previousLocation) {
          const distance = calculateDistance(
            previousLocation.lat,
            previousLocation.lng,
            newLocation.lat,
            newLocation.lng,
          );
          if (distance < minDistance) {
            onError && onError({code: 3, message: 'Location is too close'});
            return;
          }
        }

        onSuccess && onSuccess(position);
      },
      onError,
      options,
    );
  }
};
